module.exports = DM.molFeClientLogger;